import type { LoadingQueryKey } from './types';

// Define queries that need to be complete before a component is considered loaded
export const LOADING_KEYS_MAP = {
  ListingModule: ['listingSummary'],
  ConnectedListing: ['listingSummary', 'propertyDetailsOverview', 'listingRecommendations'],
  ConnectedApplications: ['applicationsSummary'],
  InterestedRenters: ['interestedRenters', 'conversationCounts', 'touringTreatment'],
  ConnectedInquiries: ['conversationCounts'],
  ConnectedPropertyCondition: ['propertyConditionSummary'],
} as const;

export const NONE_LOADING_STATE = Object.fromEntries(
  Object.values(LOADING_KEYS_MAP)
    .flat()
    .map((key) => [key, false]),
) as Record<LoadingQueryKey, boolean>;

export const INIT_LOADING_STATE = Object.fromEntries(
  Object.values(LOADING_KEYS_MAP)
    .flat()
    .map((key) => [key, true]),
) as Record<LoadingQueryKey, boolean>;

export function loadingMapReducer(
  state: Record<LoadingQueryKey, boolean>,
  action: { type: 'UPDATE_LOADING_STATE'; payload: { key: LoadingQueryKey; value: boolean } },
) {
  switch (action.type) {
    case 'UPDATE_LOADING_STATE':
      return { ...state, [action.payload.key]: action.payload.value };
    default:
      return state;
  }
}
